<template>
  <div class="pa-6">
    <div class="mb-6">
      <h2 class="text-h5 font-weight-bold mb-2">Profile information</h2>
      <p class="text-grey-darken-1">Update your name and email address</p>
    </div>

    <v-form>
      <div class="mb-6">
        <v-text-field
          v-model="displayName"
          label="Name"
          variant="outlined"
          density="comfortable"
          class="mb-4"
        />

        <v-text-field
          v-model="user.email"
          label="Email address"
          variant="outlined"
          density="comfortable"
          readonly
        />
      </div>

      <v-btn
        color="primary"
        variant="flat"
        size="large"
      >
        Save
      </v-btn>
    </v-form>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useGlobalStore } from "@/store";
import { FrontendUser } from "@YenzaCT/sdk";

const store = useGlobalStore();
const user = computed(() => store.user as FrontendUser);

const displayName = computed({
  get: () => `${user.value.profile.firstName || ""} ${user.value.profile.lastName || ""}`.trim(),
  set: (value: string) => {
    const parts = value.split(" ");
    user.value.profile.firstName = parts[0] || "";
    user.value.profile.lastName = parts.slice(1).join(" ") || "";
  }
});

</script>
